import React, { useState } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ReferalCard } from "@/components/ReferalCard/ReferalCard";
import { Pagination } from "@/ui/Pagination/Pagination";
import { useReferalsStateStore } from "@/store/referalsStateStore";
import classNames from "classnames";
import { dataTrigger } from "@/analytics";
import { useReferalsDataContext } from "@/store/ReferalsProvider";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import cls from "./styles.module.scss";

export const UnregisteredReferals = () => {
  const {
    unregisteredReferals,
    loadUnregisteredReferals,
  } = useReferalsDataContext();
  const unregisteredReferalsList = unregisteredReferals.results;
  const referalsPerPage = unregisteredReferals.limit;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isOpen = useReferalsStateStore((s) => s.isUnregisteredReferalsOpen);
  const setIsOpen = useReferalsStateStore(
    (s) => s.setIsUnregisteredReferalsOpen
  );

  const changePage = async (newPage: number) => {
    setIsLoading(true);

    setCurrentPage(newPage);
    const offset = (newPage - 1) * referalsPerPage;
    await loadUnregisteredReferals(offset);

    setIsLoading(false);
  };

  if (!unregisteredReferalsList || unregisteredReferalsList.length === 0)
    return null;

  return (
    <FlexColumn gap={8}>
      <FlexRow
        justifyContent="space-between"
        className={cls.missedReferals}
        role="tab"
        {...dataTrigger("ref.referrals.unregistered")}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <FlexRow gap={10}>
          <Typography className={cls.missedReferalsTitle}>
            Незарегистрированные рефералы
          </Typography>

          <div className={cls.refCount}>{unregisteredReferals.count} чел.</div>
        </FlexRow>

        <div
          className={classNames(cls.toggleIcon, isOpen ? cls.open : undefined)}
        >
          ▾
        </div>
      </FlexRow>

      {isOpen && (
        <>
          {isLoading ? (
            <ContainerLoader />
          ) : (
            <FlexColumn gap={14}>
              {unregisteredReferalsList.map((elem) => (
                <ReferalCard
                  key={elem.telegram_user?.telegram_id}
                  referal={elem}
                />
              ))}
            </FlexColumn>
          )}

          <Pagination
            currentPage={currentPage}
            onPageChange={changePage}
            list={unregisteredReferals}
          />
        </>
      )}
    </FlexColumn>
  );
};
